import { useTranslation } from "react-i18next"

import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"

export function PluginHeadersField({
  value,
  onChange,
}: {
  value: string
  onChange: (value: string) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="space-y-2">
      <Label htmlFor="plugin-extra-headers">{t("plugins.extraHeaders")}</Label>
      <Textarea
        className="font-mono text-xs"
        id="plugin-extra-headers"
        placeholder="User-Agent: Hello AI"
        rows={3}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <p className="text-muted-foreground text-xs">{t("plugins.extraHeadersDescription")}</p>
    </div>
  )
}
